exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainpage {\n  height: 100vh; }\n\n.sidebar-container {\n  height: 100%;\n  margin: 0;\n  padding: 0; }\n  .sidebar-container .sidebar {\n    width: 33%;\n    overflow: hidden; }\n\n.large {\n  width: 50% !important; }\n\n.sidenav-button {\n  background: rgba(255, 255, 255, 0.8);\n  margin-top: 84px;\n  position: absolute;\n  z-index: 1000;\n  height: 60px;\n  width: 20px;\n  border: none;\n  box-shadow: 2px 2px 2px #9b9b9b;\n  font-size: 20px;\n  color: #767676; }\n\n.traffic-button {\n  background: rgba(255, 255, 255, 0.65);\n  position: absolute;\n  z-index: 1000;\n  width: 120px;\n  height: 30px;\n  bottom: 15px;\n  left: 40%;\n  padding: 10px; }\n\n.show-all-button {\n  background: rgba(255, 255, 255, 0.65);\n  position: absolute;\n  z-index: 1000;\n  width: 200px;\n  height: 30px;\n  bottom: 15px;\n  left: 55%;\n  padding: 10px; }\n\n.notification {\n  position: absolute;\n  top: 150px; }\n\n.notification-show {\n  transition: 0.5s;\n  right: 20px;\n  visibility: visible;\n  opacity: 100; }\n\n.notification-hide {\n  transition: 0.5s;\n  right: 0;\n  visibility: hidden;\n  opacity: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/auth.component.scss
// module id = 1284
// module chunks = 0